"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _concept = require("./concept");
Object.keys(_concept).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _concept[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _concept[key];
    }
  });
});
var _labels = require("./labels");
Object.keys(_labels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _labels[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _labels[key];
    }
  });
});
var _product = require("./product");
Object.keys(_product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _product[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _product[key];
    }
  });
});
